module.exports = __webpack_public_path__ + "static/media/top.997e2e87.png";